module.exports = __webpack_public_path__ + "img/devicesku.6a2c3e15.svg";